import { api } from '../index';

export const getData = () => api.get('/collection-matrix');

export const getCashFlow = masterFileId => api.get(`collection-matrix/cash-flow/${masterFileId}`);
